module.exports = __webpack_public_path__ + "static/media/48.1c034c9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/48.png
// module id = 620
// module chunks = 0